export default __webpack_public_path__ + "5cd22d25a1b5519537f60c40846a432a.svg";